import { memo, useContext } from 'react';
import { eventBusExample } from '@/sub-luca-plugin/utils/class-example';
import { AnimationContainer } from '@/sub-luca-plugin/compatible-components';
import { useDebounceFn } from '@/sub-luca-plugin/utils';
import { getTransformToTeacherParams } from '@/sub-luca-plugin/components/qa-render/helper';
import { QaRecordsContext } from '../../helper';
import './indes.scss';

interface IProps {
    teacherAnswerTime: number | null;
}

const GoToTeacherQa = ({ teacherAnswerTime }: IProps) => {
    const { getQaStoreByContext } = useContext(QaRecordsContext);
    const { run } = useDebounceFn(
        () => {
            eventBusExample.publish('DialogueArea', {
                type: 'transformToTeacherQa',
                params: getTransformToTeacherParams(),
            });
        },
        { wait: 500 }
    );

    return (
        <AnimationContainer
            className="go-to-teacher-qa"
            type="enter_from_the_left"
            canExcuteAimation={getQaStoreByContext()?.qaConfig.canExcuteAimation}
        >
            <div className="go-to-teacher-qa__btn" onClick={run}>
                立即提交
            </div>
            {teacherAnswerTime !== null && (
                <div className="go-to-teacher-qa__tips">{`该科目老师预计在 ${teacherAnswerTime} 小时内回复`}</div>
            )}
        </AnimationContainer>
    );
};

export default memo(GoToTeacherQa);
